import { getEnumKey } from '@/utils/helper';

export enum PhoneNumberStatus {
  'unchecked',
  'exists',
  'doesNotExist',
  'erroneous',
  'temporarySignUpDone',
}
export enum VerificationOtpType {
  Login = 1,
  Registration,
  PhoneNumberUpdate,
}

export enum QueryKeys {
  productList = 'product-list',
  cartItems = 'cart-items',
  homepageStructure = 'homepage-structure',
  homepageSections = 'homepage-sections',
  profileData = 'get-profile-data',
  wishlist = 'wishlist',
  searchProduct = 'search-product',
  homePageCollectionProducts = 'homepage-collection-products',
  recentlyViewedProducts = 'recently-viewed-items',
  addressLists = 'address-lists',
  divisionLocation = 'division-location',
  locationLists = 'location-lists',
  megaMenu = 'mega-menu',
  popularSearch = 'popular-search',
  singleModuleProductList = 'module-product-list',
  moduleCustomFilter = 'module-custom-filter',
  moduleBanner = 'module-banner',
  storeLists = 'store-lists',
  getPaymentType = 'get-payment-type',
  orderSummary = 'order-summary',
  getOrders = 'get-orders',
  getOrderDetails = 'get-order-details',
  getInfoGraphic = 'get-info-graphic',
  rewardPoints = 'reward-points',
  rewardPointsTransaction = 'reward-points-transaction',
  voucher = 'voucher',
  brandList = 'brand-list',
  allLocation = 'all-location',
  adPopUp = 'ad-popup',
  memberExclusive = 'member-exclusive',
  memberExclusiveList = 'member-exclusive-list',
  autoComplete = 'auto-complete',
  columnBanners = 'column-banners',
  reorder = 're-order',
  recommendedProducts = 'recommended-products',
  crossCategorySuggestions = 'cross-category-suggestions',
  myLocation = 'my-location-lat-long',
  session = 'session',
  ticketList = 'ticket-list',
}
export enum ItemPosition {
  'Left' = 'Left',
  'Right' = 'Right',
}

export enum ModuleType {
  Category = 'category',
  Brand = 'brand',
}

export enum WidgetViewOptions {
  Slider = 'Slider',
  Grid = 'Grid',
}
export enum Environments {
  'Production' = 'Production',
  'Staging' = 'Staging',
  'Development' = 'Development',
  'Local' = 'Local',
}
export enum BannerTypeOptions {
  Image = 'Image',
  Video = 'Video',
  Collage = 'Collage',
}
export enum ProductCarouselType {
  'Category' = 'Category',
  'Brand' = 'Brand',
}
export enum PreKeyBannerType {
  Image = 'Image',
  Video = 'Video',
}

export enum GiftVoucher {
  gift = 'gift',
  voucher = 'voucher',
}

export enum HomepageSections {
  CategoryBrandCarousel = 'CategoryBrandCarousel',
  Collections = 'Collections',
  ColumnBanner = 'ColumnBanner',
  KeyBanner = 'KeyBanner',
  PreKeyBanner = 'PreKeyBanner',
  ProductCarousel = 'ProductCarousel',
  Slider = 'Slider',
  Widgets = 'Widgets',
  ProductCarousel2 = 'ProductCarousel2',
  Slider2 = 'Slider2',
  MemberExclusive = 'members-exclusive',
}

export enum SocialLoginUrls {
  GoogleLogin = '/google-signin',
  FacebookLogin = '/facebook-signin',
}
export enum AddressType {
  Shipping = 'Shipping',
  Billing = 'Billing',
}

export enum SubOrderStatus {
  Placed = 10,
  Processing = 20,
  Confirmed = 30,
  Cancelled = 40,
  Picking = 50,
  Dispatched = 60,
  Shipped = 70,
  Delivered = 80,
  ExchangeRequested = 90,
  RefundInitiated = 100,
  DeliveryFailed = 110,
  PaymentFailed = 120,
  RTOInitiated = 130,
  RTOClosed = 140,
}

export const getSubOrderStatus = (status: number) => {
  return getEnumKey(SubOrderStatus, status);
};

export enum DeviceType {
  Web = 'Web',
  Mobile = 'Mobile',
  Tab = 'Tab',
}

export enum POSAllocationStatus {
  NotRequested = 'NotRequested',
  Requested = 'Requested',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  AllocationFailed = 'AllocationFailed',
}
export enum RewardPointSlab {
  Nil = 'Nil',
  Regular = 'Regular',
  Silver = 'Silver',
  Gold = 'Gold',
  Platinum = 'Platinum',
}
